import { readStates, saveStates, states } from '@/constants/lifecycle';
import pagingWithFilteredResults, { openEntityDialog, sortingFilters } from '@/constants/states';
import findResult, { assignIfExists, removeItemByCode } from '@/utils/resultsHelper';
import { collectionPerms } from '@/collections/sharing/state/state';

export const datasetCollection = () => ({
  code: null,
  name: null,
  description: null,
  permissions: { ...collectionPerms() },
  imageKey: Date.now(),
  last_dataset_added_at: null,
  total_datasets: null,
});

export const datasetCollectionsState = (
  pageSize = 20,
  minFilterLength = 0,
  requiresFilter = false,
  orderBy = [{ column: 'name', direction: 'asc' }],
  singleSorting = true,
) => (
  {
    ...pagingWithFilteredResults(pageSize, minFilterLength, requiresFilter),
    ...readStates,
    ...sortingFilters(orderBy, singleSorting),
  }
);

export const collectionsInitialState = () => ({
  readStatus: states.NONE,
  readErrors: [],
  items: [],
});

export const collectionAssigningDataset = () => ({
  ...openEntityDialog,
  collectionsToAdd: [],
  name: '',
  ...saveStates,
});

export const removeDatasetCollection = () => ({
  ...openEntityDialog,
  collectionCode: '',
  name: '',
});

export const newDatasetCollection = (collection) => ({ ...collection, selected: false });

const initialState = {
  removeDatasetCollectionConfirmation: removeDatasetCollection(),
  collectionAssigningDataset: collectionAssigningDataset(),
  datasetCollections: {
    open: {
      results: [],
    },
    settings: {
      results: [],
    },
    entities: [],
  },
};

export const findDatasetCollection = ({ datasetCollections }, { category, code }) => (
  findResult(datasetCollections, category, code)
);

export const closeDatasetCollectionState = (draft, { category, code }) => {
  const item = findDatasetCollection(draft, { category, code });
  if (item) {
    draft.datasetCollections[category].results = (
      removeItemByCode(draft.datasetCollections[category].results, item));
  }
};

export const updateDatasetCollectionsListState = (draft, collection) => {
  draft.datasetCollections.entities.forEach((dsc) => {
    const item = dsc.results.find(({ code }) => code === collection.code);
    if (item) {
      assignIfExists(item, collection);
    }
  });
};

export default initialState;
